import { render, staticRenderFns } from "./ViewPage.vue?vue&type=template&id=c901129c&scoped=true&"
import script from "./ViewPage.vue?vue&type=script&lang=js&"
export * from "./ViewPage.vue?vue&type=script&lang=js&"
import style0 from "./ViewPage.vue?vue&type=style&index=0&id=c901129c&prod&scoped=true&lang=css&"
import style1 from "./ViewPage.vue?vue&type=style&index=1&id=c901129c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c901129c",
  null
  
)

export default component.exports